import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Page, PageHeader, SearchBar } from 'components';
import { UsersTable, UserOrgSelector, UserPropertyForm } from './components';
import { Dialog, Box } from '@material-ui/core';
import _ from 'lodash';
import { Roles } from 'utils/authHelpers';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',
    height: '100%',
    minHeight: '100%',
    flex: 1,
  },
  spacing: {
    marginBottom: theme.spacing(2),
  },
}));

const UsersPropertiesPage = ({
  setUserOrgName,
  setFilterByOrg,
  fetchUsers,
  instancePermissions,
  instanceRoles,
  users,
  isFetchingUsers,
  organizations,
  filterByOrg,
  selectedOrganization,
  currentUserRoles,
  saveUser,
  isSuper,
}) => {
  const classes = useStyles();

  const { t } = useTranslation();
  const [modal, setModal] = useState(false);

  const [searchText, setSearchText] = useState('');
  const [selectedUser, setSelectedUser] = useState();
  const [filteredUsers, setFilteredUsers] = useState([]);

  useEffect(() => {
    let limitedUsers = _.filter(users, (user) => {
      return user.roles && user.roles.length == 1 && user.roles[0] == 'user';
    });

    setFilteredUsers(limitedUsers);
  }, [users]);

  useEffect(() => {
    if (isSuper && (!users || users?.length === 0)) {
      if (selectedOrganization) {
        fetchUsers(selectedOrganization.id);
        setFilterByOrg(selectedOrganization.name);
      } else {
        fetchUsers();
      }
    } else if (!isSuper && (!users || users?.length === 0) && selectedOrganization) {
      fetchUsers(selectedOrganization.id);
      setFilterByOrg(selectedOrganization.name);
    }
  }, []);

  return (
    <Page title={t('user_property_admin')} className={classes.root}>
      <Dialog open={modal} onClose={() => setModal(false)} scroll="paper">
        <Box>
          <UserPropertyForm
            handleCloseModal={() => setModal(!modal)}
            instancePermissions={instancePermissions}
            instanceRoles={instanceRoles}
            userToEdit={selectedUser}
            onSave={saveUser}
            organizations={organizations}
            selectedOrganization={selectedOrganization}
            currentUserRoles={currentUserRoles}
          />
        </Box>
      </Dialog>

      <PageHeader className={classes.spacing} title={t('user_property_admin')} />
      {_.includes(currentUserRoles, Roles.Super) && (
        <div className={classes.spacing}>
          <UserOrgSelector
            setUserOrgName={setUserOrgName}
            organizations={organizations}
            fetchUsers={fetchUsers}
            setFilterByOrg={setFilterByOrg}
            filterByOrg={filterByOrg}
          />
        </div>
      )}

      <SearchBar className={classes.spacing} selector={searchText} setSearchText={setSearchText} />
      <UsersTable
        searchText={searchText}
        setModal={setModal}
        setSelectedUser={setSelectedUser}
        className={classes.spacing}
        users={filteredUsers}
        isFetchingUsers={isFetchingUsers}
        organizations={organizations}
        selectedUser={selectedUser}
      />
    </Page>
  );
};

UsersPropertiesPage.propTypes = {
  setUserOrgName: PropTypes.func.isRequired,
  fetchUsers: PropTypes.func.isRequired,
  setFilterByOrg: PropTypes.func.isRequired,
  setSelectedUser: PropTypes.func.isRequired,
  inviteUser: PropTypes.func.isRequired,
  saveUser: PropTypes.func.isRequired,
  instancePermissions: PropTypes.object,
  instanceRoles: PropTypes.object,
  users: PropTypes.array,
  isFetchingUsers: PropTypes.bool,
  organizations: PropTypes.array,
  filterByOrg: PropTypes.string,
  selectedOrganization: PropTypes.object,
  currentUserRoles: PropTypes.array,
  selectedUser: PropTypes.object,
  isSuper: PropTypes.bool,
};

UsersPropertiesPage.defaultProps = {
  instancePermissions: undefined,
  instanceRoles: undefined,
  users: [],
  isFetchingUsers: true,
  organizations: [],
  filterByOrg: '',
  selectedOrganization: undefined,
  currentUserRoles: [],
  selectedUser: undefined,
  isSuper: false,
};

export default UsersPropertiesPage;
